import { checkAndRequestPermissionH5 } from '../permission/index'
// import { Toast } from 'mint-ui'

/*
 * @Author: guangrong guo
 * @Email:543109047@qq.com
 * @Date: 2019-07-01 10:41:03
 * @Dec: 全局指令
 */
import frozen from '../vue-frozen-scroll'
/* 输入框失去焦点自动恢复页面高度 */
export let fixedInput = (el, binding) => {
  const windowHeight = window.innerHeight
  el.addEventListener('blur', function () {
    let windowFocusHeight = window.innerHeight
    if (windowHeight === windowFocusHeight) {
      return
    }
    let currentPosition
    let speed = 1 // 页面滚动距离
    currentPosition = document.documentElement.scrollTop || document.body.scrollTop
    currentPosition -= speed
    window.scrollTo(0, currentPosition) // 页面向上滚动
    currentPosition += speed // speed变量
    window.scrollTo(0, currentPosition) // 页面向下滚动
  })
}
/* 阻止滚动事件穿透 */
export let preventScroll = {
  bind (el, binding) { // el是绑定指令的元素
    el.addEventListener('touchstart', (e) => {
      frozen.touchStart(e)
    }, false)
    el.addEventListener('touchmove', (e) => {
      e.stopPropagation()
      frozen.touchMove(e, el)
    }, false)
    el.addEventListener('touchend', (e) => {
      e.stopPropagation()
    }, false)
  },
  unbind (el) {
    el.removeEventListener('touchstart', (e) => {
      frozen.touchStart(e)
    }, false)
    el.removeEventListener('touchmove', (e) => {
      frozen.touchMove(e, el)
    }, false)
  }
}

// v-autoHeight="20" 输入框自动高度
export let autoHeight = {
  update (el, binding) {
    const { value } = binding
    if (value && typeof value === 'number') {
      el.style.height = `${value}px`
    } else {
      el.style.height = 'auto'
    }
  },
  componentUpdated (el) {
    el.style.height = `${el.scrollHeight}px`
  }
}

// 注册全局自定义指令 v-permission
export let permission = {
  /**
   * 当指令绑定的元素插入到 DOM 中时调用
   * @param {HTMLElement} el - 指令所绑定的元素
   * @param {Object} binding - 一个对象，包含指令的信息
   */
  inserted (el, binding) {
    // 从 binding.value 中解构出 permission 和 handler
    const { permission: permissionType, handler: originalHandler } = binding.value

    // 校验传入的参数是否合法
    if (!permissionType || typeof originalHandler !== 'function') {
      console.error(
        'v-permission 指令参数错误！必须传入 { permission: string, handler: Function }'
      )
      return
    }

    // 定义我们的点击事件处理器
    const handleClick = async (event) => {
      // 阻止事件的默认行为和冒泡，逻辑决定是否放行
      event.stopPropagation()
      event.preventDefault()

      // 执行异步的权限检查
      const permissionResult = await checkAndRequestPermissionH5(permissionType)

      if (permissionResult.granted) {
        console.log(`权限[${permissionType}]通过，执行操作。`)
        // 如果是 <input> 元素
        if (el.tagName === 'INPUT') {
          // 检查 input 的 type 是否为 'file'
          if (el.type === 'file') {
            console.log('v-permission: 检测到是文件输入框，准备手动触发点击。')

            // 1. 临时移除我们的自定义点击事件，防止无限循环
            el.removeEventListener('click', handleClick)

            // 2. 触发元素的原生点击事件，这会弹出文件选择框
            el.click()

            // 3. 在当前同步代码执行完毕后，重新添加我们的自定义点击事件
            //    使用 setTimeout(fn, 0) 将任务推入任务队列，等待下一次事件循环
            setTimeout(() => {
              el.addEventListener('click', handleClick)
            }, 0)
          } else {
            // 如果是其他类型的 input (如 type="button"), 直接执行 handler
            originalHandler(event)
          }
        } else {
          // 对于所有其他元素 (如 <button>, <div>), 直接执行用户提供的 handler 函数
          console.log('v-permission: 执行用户提供的 handler 函数。')
          originalHandler(event)
        }
      } else {
        // 如果权限被拒绝
        console.log(`权限[${permissionType}]不足，操作被阻止。`)
        // Toast(`需要${permissionType}权限才能执行此操作`)
      }
    }

    // 给元素添加我们自定义的点击事件监听器
    el.addEventListener('click', handleClick)
    el.__v_permission_handler__ = handleClick
  },

  /**
   * 当指令与元素解绑时调用
   * @param {HTMLElement} el - 指令所绑定的元素
   */
  unbind (el) {
    // 从元素上获取我们存储的事件处理器
    const handler = el.__v_permission_handler__

    // 如果处理器存在，就从元素上移除事件监听，防止内存泄漏
    if (handler && typeof handler === 'function') {
      el.removeEventListener('click', handler)
      // 清理自定义属性
      delete el.__v_permission_handler__
    }
  }
}
